
import React, { useContext } from 'react';
import AppContext from '../context/app/appContext';

const SelectedFilters = (props) => {

    const appContext = useContext(AppContext);

    const optionToggle = (event, ident, optionIdent) => {
        if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            appContext.toggleSelectedOption({ filterIdent: ident, optionIdent: optionIdent });
        }
    }

    const resetDateRange = (event) => {
        if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            appContext.resetDateRange()
        }
    }

    return (
        <div className="inner-filter">
            <ul>
                {Object.keys(appContext.activeOptions).map((keyName, z) => {
                    return (appContext.activeOptions[keyName].map((optionIdent, i) => {
                        return (
                            <li
                                key={i}
                                onClick={(event) => optionToggle(event, keyName, optionIdent)}
                                onKeyDown={(event) => optionToggle(event, keyName, optionIdent)}
                            >
                                <strong>{appContext.dictionaries[keyName][optionIdent]}</strong><span></span>
                            </li>
                        )
                    }))
                })}

                {
                    appContext.dateRange.min > 0 && (appContext.dateRange.min !== appContext.dataRangeMin || appContext.dateRange.max !== appContext.dataRangeMax) &&
                    <li
                        onClick={(event) => resetDateRange(event)}
                        onKeyDown={(event) => resetDateRange(event)}
                    >
                        <strong>{appContext.dateRange.min} - {appContext.dateRange.max}</strong><span></span>
                    </li>
                }


            </ul>
        </div>
    );
}

export default SelectedFilters;